import { BaseService } from './base'
import { APIPath } from '../constant/api'
import axios from 'axios'
import { AuthService } from '../services'

// Use a distinct class name to avoid collision with the exported instance name
class AITemplateApi {
	async getLanguages(callFrom = null) {
		// Add CallFrom header if specified
		if (callFrom) {
			const headers = {}
			headers.CallFrom = callFrom

			const token = AuthService.getToken()
			headers['X-TOKEN'] = token
			headers['X-Recaptcha'] = ''
			headers.app = 'EAuditor'
			headers['Access-Control-Allow-Origin'] = '*'
			headers['X-LoginSource'] = '1'

			const client = axios.create({
				baseURL: APIPath.server,
				headers: { ...headers },
			})

			return client.get(APIPath.aiTemplateLanguage).then(response => response.data)
		}

		return BaseService.get(APIPath.aiTemplateLanguage)
	}

	async getIndustriesWithSubcategories() {
		return BaseService.get(APIPath.aiTemplateIndustry)
	}

	async generateTemplate(params, recaptchaToken = null) {
		const queryParams = new URLSearchParams()

		if (params.industry) queryParams.append('industry', params.industry)
		// Always include subcategory, even if empty string was passed
		queryParams.append('subcategory', params.subcategory ?? '')
		if (params.questionCount) queryParams.append('questionCount', params.questionCount)
		if (params.templateTitle) queryParams.append('templateTitle', params.templateTitle)
		if (params.language) queryParams.append('language', params.language)

		const url = `${APIPath.aiTemplateGenerate}?${queryParams.toString()}`
		return BaseService.get(url, true, recaptchaToken)
	}

	async importTemplate(payload, recaptchaToken = null) {
		return BaseService.post(APIPath.aiTemplateImport, payload, true, recaptchaToken)
	}
}

// Export instance with the expected name used across the app
export const AITemplateService = new AITemplateApi()
